// cart-message-validation.js
const MESSAGE_CARD_VALIDATION = {
    MAX_LENGTH: 100,
    ALLOWED_PATTERN: /^[ぁ-んァ-ンー-龥a-zA-Z0-9０-９\s。、！？!?\-]+$/,
    ERROR_MESSAGES: {
      get MAX_LENGTH() {
        return window.messageCardErrors?.maxLength || '100文字以内で入力してください。';
      },
      get INVALID_CHARS() {
        return window.messageCardErrors?.invalidChars || '使用できない文字が含まれています。';
      }
    }
  };
  
  class MessageCardValidator {
    constructor(textAreaId, submitButtonId) {
      this.textArea = document.getElementById(textAreaId);
      this.submitButton = document.getElementById(submitButtonId);
      this.errorContainer = null;
      
      if (this.textArea && this.submitButton) {
        this.init();
      }
    }
  
    init() {
      this.createErrorContainer();
      
      this.textArea.addEventListener('input', () => this.validate());
      this.textArea.addEventListener('paste', (e) => {
        setTimeout(() => this.validate(), 0);
      });
  
      this.validate();
    }
  
    createErrorContainer() {
        const existingError = this.textArea.parentNode.querySelector('.message-card-error');
        if (existingError) {
          existingError.remove();
        }
      
        const saveButton = document.getElementById('saveMessageButton');
      
        this.errorContainer = document.createElement('div');
        this.errorContainer.className = 'message-card-error';
        this.errorContainer.style.color = '#dc3545';
        this.errorContainer.style.fontSize = '0.7rem';
        this.errorContainer.style.marginTop = '0.5rem';
        this.errorContainer.style.marginBottom = '0.5rem';
      
        if (saveButton) {
          saveButton.parentNode.insertBefore(this.errorContainer, saveButton);
        }
      }
  
    validate() {
      const text = this.textArea.value;
      const errors = [];
  
      if (text.length > MESSAGE_CARD_VALIDATION.MAX_LENGTH) {
        errors.push(MESSAGE_CARD_VALIDATION.ERROR_MESSAGES.MAX_LENGTH);
      }
  
      if (text && !MESSAGE_CARD_VALIDATION.ALLOWED_PATTERN.test(text)) {
        errors.push(MESSAGE_CARD_VALIDATION.ERROR_MESSAGES.INVALID_CHARS);
      }
  
      this.updateErrorDisplay(errors);
  
      this.submitButton.disabled = errors.length > 0;
  
      return errors.length === 0;
    }
  
    updateErrorDisplay(errors) {
      if (errors.length > 0) {
        this.errorContainer.innerHTML = errors.join('<br>');
        this.textArea.style.borderColor = '#dc3545';
      } else {
        this.errorContainer.innerHTML = '';
        this.textArea.style.borderColor = '';
      }
    }
  
    isValid() {
      return this.validate();
    }
  }
  
  function addCharacterCounter(textAreaId) {
    const textArea = document.getElementById(textAreaId);
    if (!textArea) return;
  
    const existingCounter = textArea.parentNode.querySelector('.character-counter');
    if (existingCounter) {
      existingCounter.remove();
    }
  
    const container = document.createElement('div');
    container.className = 'character-counter';
    
    textArea.parentNode.insertBefore(container, textArea.nextSibling);
  
    function updateCounter() {
        const count = textArea.value.length;
        const unit = window.messageCardErrors?.characterUnit || '文字';
        container.textContent = `${count}/${MESSAGE_CARD_VALIDATION.MAX_LENGTH}${unit}`;
        
        container.classList.toggle('character-counter--error', count > MESSAGE_CARD_VALIDATION.MAX_LENGTH);
    }
  
    textArea.addEventListener('input', updateCounter);
    textArea.addEventListener('paste', () => setTimeout(updateCounter, 0));
    
    updateCounter();
  }
  
  window.MessageCardValidator = MessageCardValidator;
  window.addCharacterCounter = addCharacterCounter;